import { GET_GLOBAL_WHATS_NEW, ADD_GLOBAL_WHATS_NEW, UPDATE_GLOBAL_WHATS_NEW, DELETE_GLOBAL_WHATS_NEW } from "../types";

const initialState = { list: [], single: null };

const reducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case GET_GLOBAL_WHATS_NEW:
            return { ...state, list: payload };

        case UPDATE_GLOBAL_WHATS_NEW:
            return {
                ...state,
                list: state.list.map((item) =>
                    item.id === payload._id ? payload : item
                ),
            };

        case ADD_GLOBAL_WHATS_NEW:
                return {
                    ...state,
                    list: [payload, ...state.list],
                };

        case DELETE_GLOBAL_WHATS_NEW:
            return {
                ...state,
                list: state.list.filter((item) => item._id !== payload._id),
            };

        default:
            return state;
    }
};

export default reducer;
